<script lang="ts">
  // Audiofrage: prozedurale Melodie oder Morsezeichen abspielen (mit Text-Alternative für Barrierefreiheit)
  import type { AudioSpec } from '../../../shared/types.ts';
  import { audio } from '../../audio/audio.ts';
  import { t } from '../../i18n.ts';

  let { spec }: { spec: AudioSpec } = $props();
  let playing = $state(false);
  let showText = $state(false);

  function play() {
    audio.unlock();
    const ms = spec.kind === 'melody' ? audio.melody(spec.notes, spec.bpm ?? 100) : audio.morse(spec.code, spec.wpm ?? 12);
    playing = true;
    setTimeout(() => (playing = false), Math.max(500, ms));
  }
  const alt = $derived(spec.kind === 'morse' ? spec.code.replace(/\./g, '·').replace(/-/g, '–') : spec.notes.map(([n]) => n.replace(/\d/, '')).join(' '));
</script>

<div class="audio">
  <button class="btn primary play" class:playing onclick={play} data-testid="quiz-play">
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5v14l12-7z" fill="currentColor" /></svg>
    {playing ? t('quiz.playing') : t('quiz.play')}
  </button>
  <button class="link" onclick={() => (showText = !showText)} aria-expanded={showText}>{t('quiz.audioText')}</button>
  {#if showText}<p class="alt" data-testid="quiz-audio-text">{alt}</p>{/if}
</div>

<style>
  .audio {
    display: grid;
    justify-items: center;
    gap: 6px;
    margin-bottom: 14px;
  }
  .play {
    display: inline-flex;
    gap: 8px;
    align-items: center;
  }
  .play.playing {
    animation: pulse 0.8s infinite alternate;
  }
  @keyframes pulse {
    to {
      box-shadow: 0 0 0 8px rgba(246, 200, 109, 0.25);
    }
  }
  .link {
    background: none;
    border: 0;
    color: var(--amber2);
    text-decoration: underline;
    min-height: 44px;
  }
  .alt {
    margin: 0;
    font-family: monospace;
    font-size: 1.1rem;
    letter-spacing: 0.1em;
  }
</style>
